import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4f0f7b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "service-page"
}
const _hoisted_2 = { class: "service-page__header wrapper" }
const _hoisted_3 = { class: "service-page__title" }
const _hoisted_4 = {
  key: 1,
  class: "service-page__map-address body-2"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 2,
  class: "service-page__target-group"
}
const _hoisted_7 = { class: "service-page__target-items" }
const _hoisted_8 = { class: "service-page__service" }
const _hoisted_9 = { class: "service-page__service-section" }
const _hoisted_10 = { class: "service-page__service-section-header" }
const _hoisted_11 = { class: "service-page__service-description" }
const _hoisted_12 = { class: "service-page__preferences" }
const _hoisted_13 = {
  key: 0,
  class: "service-page__preferences-item"
}
const _hoisted_14 = { class: "body-2-semi" }
const _hoisted_15 = { class: "body-2" }
const _hoisted_16 = {
  key: 1,
  class: "service-page__preferences-item"
}
const _hoisted_17 = { class: "body-2-semi" }
const _hoisted_18 = { class: "body-2" }
const _hoisted_19 = {
  key: 0,
  class: "service-page__service-section-expandable"
}
const _hoisted_20 = {
  key: 0,
  class: "service-page__service-section"
}
const _hoisted_21 = { class: "service-page__housing-rooms-wrapper" }
const _hoisted_22 = {
  key: 1,
  class: "service-page__service-section"
}
const _hoisted_23 = { class: "service-page__service-section-header" }
const _hoisted_24 = { class: "service-page__service-amenities" }
const _hoisted_25 = {
  key: 0,
  class: "service-page__service-section-table"
}
const _hoisted_26 = { class: "service-page__service-section-amenity" }
const _hoisted_27 = {
  key: 3,
  class: "service-page__contact-section"
}
const _hoisted_28 = { class: "service-page__service-contact-info" }
const _hoisted_29 = { class: "service-page__service-section-header" }
const _hoisted_30 = {
  key: 0,
  class: "service-page__service-section-contact body-2-semi"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"24px"} }, null, -1))
const _hoisted_32 = {
  key: 1,
  class: "service-page__service-section-contact"
}
const _hoisted_33 = {
  key: 2,
  class: "service-page__service-section-contact"
}
const _hoisted_34 = {
  key: 3,
  class: "service-page__service-section-contact"
}
const _hoisted_35 = { class: "service-page__social-media" }
const _hoisted_36 = {
  key: 0,
  class: "service-page__social-media-item"
}
const _hoisted_37 = ["href"]
const _hoisted_38 = ["src", "alt"]
const _hoisted_39 = { class: "service-page__social-media-hovertext body-2" }

import BaseIcon from '@/components/BaseIcon.vue'
import BaseButton from '@/components/BaseButton.vue'
import ProgressBar from '@/components/ProgressBar.vue'
import ServiceNotFound from '@/components/public/ServiceNotFound.vue'
import ServiceHousing from '@/components/public/ServiceHousing.vue'
import ServiceEvent from '@/components/public/ServiceEvent.vue'
import ServiceExperience from '@/components/public/ServiceExperience.vue'
import HousingRoomCard from '@/components/public/housing/HousingRoomCard.vue'
import ServiceLocationInformation from '@/components/public/ServiceLocationInformation.vue'
import ScrollWrapper from '@/components/misc/ScrollWrapper.vue'
import { ALERT_TYPES, FORMATS, SIZES } from '@/enums/components'
import { useServiceQuery } from '@/queries/public/services'
import { computed, ref, PropType, VueElement, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { Order, OrderItemReferral } from '@/models/public/order.model'
import { useFetchCart } from '@/queries/cart'
import { amenityIcons, targetGroupIcons } from '@/utils/labelIcons'
import { useOrderStore } from '@/store/order'
import { ServiceType } from '@/enums/services'
import { Alert } from '@/models/shared.model'
import { SERVICE_DIFFICULTY } from '@/components/service/ServiceDifficultySlider.vue'
import {
  PublicServiceAmenityItem,
  PublicServiceTargetGroupItem,
} from '@/models/public/service.model'
import {
  servicePublicDetailsCommonProps,
  TRANSLATION_TYPE,
} from '@/enums/public'
import { getGlobalLocale } from '@/utils/formatters'
import ServiceProduct from '@/components/public/ServiceProduct.vue'
import ServiceGroup from '@/components/public/group/PublicServiceGroup.vue'
import ServiceTicket from '@/components/public/ticket/ServiceTicket.vue'
import { useAuthStore } from '@/store/auth'
import { storeToRefs } from 'pinia'
import { useFetchCompanyColorPreferences } from '@/queries/settings.queries'

export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceView',
  props: {
  serviceId: {
    // It can be either id or its hashed string form
    type: [Number, String] as PropType<number | string>,
    required: true,
  },
  isPreview: {
    type: Boolean,
    default: false,
  },
  referral: {
    type: Object as PropType<OrderItemReferral | undefined>,
    default: undefined,
  },
  hideRelated: servicePublicDetailsCommonProps.hideRelated,
  hideTitle: Boolean,
  hideOrdering: Boolean,
},
  setup(__props) {

const props = __props

_useCssVars(_ctx => ({
  "1c6fe381": (companyColorPreferences.value?.primary_dark),
  "164c4144": (companyColorPreferences.value?.primary_light_2),
  "150e5046": (companyColorPreferences.value?.secondary),
  "377ed862": (companyColorPreferences.value?.secondary_dark),
  "7200c26b": (companyColorPreferences.value?.primary_light),
  "59970d58": (companyColorPreferences.value?.primary),
  "164c4146": (companyColorPreferences.value?.primary_light_1)
}))

const i18n = useI18n()
const errors = ref()
const orderStore = useOrderStore()
const authStore = useAuthStore()
const { selectedCompanyId } = storeToRefs(authStore)



// Public view gets id as hashed string, service provider preview gets actual numeric id
const serviceId = ref<string | number>(props.serviceId)
const companyId = ref<number | null>(null)
const companyColorPreferences = ref()

const {
  isLoading,
  isError,
  mutateAsync: fetchService,
  data: service,
} = useServiceQuery(serviceId, props.isPreview)

fetchService()

const { isLoading: isCartLoading, mutateAsync: fetchCart } = useFetchCart(
  sessionStorage.getItem('order-uuid'),
)

const mapsUrl = computed(() => {
  return (
    'https://maps.google.com/?q=' +
    service.value?.location?.latitude_decimal_degree +
    ',' +
    service.value?.location?.longitude_decimal_degree
  )
})

const target_groups = ref<PublicServiceTargetGroupItem[]>([])

const showLessDescription = ref(true)
const isOverMinimumDescription = computed(() => {
  return service.value
    ? service.value?.description?.content.length > 500
    : false
})

const showLessAmenities = ref(true)
const serviceAmenities = ref<PublicServiceAmenityItem[]>([])
const isShowAllButtonShown = computed(() => {
  return serviceAmenities.value.length > 6
})
const showMinimumAmenities = computed(() => {
  if (showLessAmenities?.value) {
    return serviceAmenities.value?.slice(0, 4)
  } else {
    return serviceAmenities.value
  }
})

const serviceComponent = computed<VueElement>(() => {
  switch (service.value?.type) {
    case ServiceType.HOUSING:
      return ServiceHousing
    case ServiceType.EVENT:
      return ServiceEvent
    case ServiceType.EXPERIENCE:
      return ServiceExperience
    case ServiceType.MONEYJAR:
      return ServiceEvent
    case ServiceType.PRODUCT:
      return ServiceProduct
    case ServiceType.TICKET:
      return ServiceTicket
    case ServiceType.GROUP:
      return ServiceGroup
    default:
      return null
  }
})

const socialMedia = computed(() => {
  return {
    facebook: service.value?.company.facebook,
    instagram: service.value?.company.instagram,
    linkedin: service.value?.company.linkedin,
    twitter: service.value?.company.twitter,
  }
})

const loadPendingOrder = () => {
  fetchCart().then((data: Order) => {
    orderStore.updateOrder(data)
  })
}
sessionStorage.getItem('order-uuid') && loadPendingOrder()

const alerts = computed<Alert[]>(() => {
  const alertList: Alert[] = [...orderStore.orderAlerts]

  const nonFieldErrors = (errors.value?.non_field_errors || []) as Array<string>
  for (const errorMessage of nonFieldErrors) {
    alertList.push({
      text: errorMessage,
      alertType: ALERT_TYPES.DANGER,
    })
  }

  return alertList
})

const getDifficulty = (key: SERVICE_DIFFICULTY) => {
  return {
    [SERVICE_DIFFICULTY.NEUTRAL]: i18n.t(
      'servicePreferences.difficultyLabels.neutral',
    ),
    [SERVICE_DIFFICULTY.EASY]: i18n.t(
      'servicePreferences.difficultyLabels.easy',
    ),
    [SERVICE_DIFFICULTY.MEDIUM]: i18n.t(
      'servicePreferences.difficultyLabels.medium',
    ),
    [SERVICE_DIFFICULTY.HARD]: i18n.t(
      'servicePreferences.difficultyLabels.hard',
    ),
  }[key]
}

const enableOrdering = computed<boolean>(() => {
  if (props.hideOrdering) {
    return false
  }
  return !!service.value?.can_order
})

const {
  isLoading: isFetchCompanyPreferencesLoading,
  mutateAsync: fetchCompanyColorPreferences,
} = useFetchCompanyColorPreferences(companyId)

const getCompanyColorPreferences = () => {
  fetchCompanyColorPreferences().then(
    (data) => (companyColorPreferences.value = data),
  )
}

watch(
  () => service.value,
  () => {
    if (service.value) {
      serviceAmenities.value = service.value.amenities
      target_groups.value = service.value.target_groups
      companyId.value = service.value.company.id
    }
  },
)

watch(
  () => getGlobalLocale(),
  () => {
    if (service.value) {
      fetchService()
    }
  },
  { immediate: true },
)

watch(
  () => companyId.value,
  () => {
    if (companyId.value) {
      getCompanyColorPreferences()
    }
  },
)

return (_ctx: any,_cache: any) => {
  const _component_AlertBanner = _resolveComponent("AlertBanner")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(isLoading) || _unref(isCartLoading))
      ? (_openBlock(), _createBlock(ProgressBar, { key: 0 }))
      : (_unref(isError))
        ? (_openBlock(), _createBlock(ServiceNotFound, { key: 1 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alerts), (alert, alertIndex) => {
              return (_openBlock(), _createBlock(_component_AlertBanner, _mergeProps({ key: alertIndex }, alert), null, 16))
            }), 128)),
            (_unref(service)?.archived_at)
              ? (_openBlock(), _createBlock(_component_AlertBanner, {
                  key: 0,
                  text: _ctx.$t('publicService.archivedAlert'),
                  "alert-type": _unref(ALERT_TYPES).DANGER
                }, null, 8, ["text", "alert-type"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              (!__props.hideTitle)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(service)?.name?.content), 1),
                    (_unref(service)?.description?.type === _unref(TRANSLATION_TYPE).MACHINE)
                      ? (_openBlock(), _createBlock(BaseIcon, {
                          key: 0,
                          icon: "google-translate",
                          style: {"height":"16px","width":"revert","display":"block"}
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (_unref(service)?.location?.address?.full_address)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(BaseIcon, {
                      icon: "map-pin",
                      size: 16,
                      class: "service-page__map-address-icon"
                    }),
                    _createElementVNode("a", {
                      href: _unref(mapsUrl),
                      target: "_blank",
                      class: "service-page__map-url"
                    }, _toDisplayString(_unref(service)?.location?.address?.full_address), 9, _hoisted_5)
                  ]))
                : _createCommentVNode("", true),
              (_unref(service)?.target_groups.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("h6", null, _toDisplayString(_ctx.$t('preferences.labels.target')), 1),
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(target_groups.value, (target) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: target.id,
                          class: "service-page__target-item"
                        }, [
                          _createVNode(BaseIcon, {
                            icon: _unref(targetGroupIcons)[target.id],
                            size: 24,
                            class: "service-page__target-icon"
                          }, null, 8, ["icon"]),
                          _createElementVNode("div", null, _toDisplayString(target?.name), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(serviceComponent)), {
              "service-id": serviceId.value,
              service: _unref(service),
              "is-preview": __props.isPreview,
              "enable-ordering": _unref(enableOrdering),
              referral: __props.referral,
              "hide-related": __props.hideRelated
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t('aboutTheExperience')), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createTextVNode(_toDisplayString(showLessDescription.value && _unref(isOverMinimumDescription)
                  ? _unref(service)?.description?.content.slice(0, 300) + '...'
                  : _unref(service)?.description?.content) + " ", 1),
                      (_unref(service)?.description?.type === _unref(TRANSLATION_TYPE).MACHINE)
                        ? (_openBlock(), _createBlock(BaseIcon, {
                            key: 0,
                            icon: "google-translate",
                            style: {"height":"16px","width":"revert","display":"block","margin-top":"10px"}
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      (_unref(service)?.difficulty_level)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('preferences.labels.difficulty')) + ": ", 1),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(getDifficulty(_unref(service)?.difficulty_level)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(service)?.route_distance)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('distance')) + ": ", 1),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(Number(_unref(service)?.route_distance)) + " km", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_unref(isOverMinimumDescription))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(BaseButton, {
                            label: showLessDescription.value ? _ctx.$t('readMore') : _ctx.$t('readLess'),
                            format: _unref(FORMATS).TERTIARY,
                            size: _unref(SIZES).SMALL,
                            icon: showLessDescription.value ? 'chevron-down' : 'chevron-up',
                            "icon-right": "",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(
                  () => (showLessDescription.value = !showLessDescription.value)
                , ["prevent"]))
                          }, null, 8, ["label", "format", "size", "icon"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_unref(service)?.type === _unref(ServiceType).HOUSING)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(ScrollWrapper, { "scroll-amount": 190 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_21, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(service)?.housings_information?.rooms, (room) => {
                                return (_openBlock(), _createBlock(HousingRoomCard, {
                                  key: room.id,
                                  "housing-room": room
                                }, null, 8, ["housing-room"]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (serviceAmenities.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.$t('amenities')), 1),
                        _createElementVNode("div", _hoisted_24, [
                          (_unref(showMinimumAmenities))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showMinimumAmenities), (amenity) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: amenity.id,
                                    class: "service-page__service-section-cell"
                                  }, [
                                    _createElementVNode("div", _hoisted_26, [
                                      _createVNode(BaseIcon, {
                                        icon: _unref(amenityIcons)[amenity.id],
                                        size: 24
                                      }, null, 8, ["icon"]),
                                      _createTextVNode(" " + _toDisplayString(amenity.name), 1)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(["service-page__service-section-expandable service-page__service-section-expandable--left", {
                  'service-page__service-section-expandable--false':
                    !_unref(isShowAllButtonShown),
                }])
                          }, [
                            (_unref(isShowAllButtonShown))
                              ? (_openBlock(), _createBlock(BaseButton, {
                                  key: 0,
                                  label: 
                    showLessAmenities.value
                      ? _ctx.$t('showAllAmenities', {
                          numOfAmenities: serviceAmenities.value.length,
                        })
                      : _ctx.$t('showLess')
                  ,
                                  format: _unref(FORMATS).TERTIARY,
                                  size: _unref(SIZES).SMALL,
                                  icon: showLessAmenities.value ? 'chevron-down' : 'chevron-up',
                                  "icon-right": "",
                                  class: "service-page__service-section-expandable-button",
                                  onClick: _cache[1] || (_cache[1] = _withModifiers(
                    () => (showLessAmenities.value = !showLessAmenities.value)
                  , ["prevent"]))
                                }, null, 8, ["label", "format", "size", "icon"]))
                              : _createCommentVNode("", true)
                          ], 2)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(service)?.location)
                    ? (_openBlock(), _createBlock(ServiceLocationInformation, {
                        key: 2,
                        "model-value": _unref(service).location,
                        class: "service-page__service-section"
                      }, null, 8, ["model-value"]))
                    : _createCommentVNode("", true),
                  (_unref(service)?.contact_info)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.$t('contactServiceProvider')), 1),
                            (_unref(service)?.contact_info?.company_name)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                  _hoisted_31,
                                  _createTextVNode(" " + _toDisplayString(_unref(service)?.contact_info?.company_name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(service)?.contact_info?.name)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                  _createVNode(BaseIcon, {
                                    icon: "user",
                                    size: 24
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_unref(service)?.contact_info?.name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(service)?.contact_info?.email)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                  _createVNode(BaseIcon, {
                                    icon: "envelope-simple",
                                    size: 24
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_unref(service)?.contact_info?.email), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(service)?.contact_info?.phone)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                  _createVNode(BaseIcon, {
                                    icon: "phone",
                                    size: 24
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_unref(service)?.contact_info?.phone), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(socialMedia), (socialMediaUrl, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                (socialMediaUrl?.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                      _createElementVNode("a", {
                                        href: socialMediaUrl,
                                        target: "_blank"
                                      }, [
                                        _createElementVNode("img", {
                                          src: require(`@/assets/images/${index}.png`),
                                          alt: index,
                                          class: "service-page__social-media-item-logo",
                                          height: "32"
                                        }, null, 8, _hoisted_38),
                                        _createElementVNode("div", _hoisted_39, _toDisplayString(index.toUpperCase()), 1)
                                      ], 8, _hoisted_37)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["service-id", "service", "is-preview", "enable-ordering", "referral", "hide-related"]))
          ]))
  ]))
}
}

})